var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAirplane = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 48,
    viewBox: "0 0 39 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "5wjckmvxoa",
    d: "M0.059 0.062L13.105 0.062 13.105 15.485 0.059 15.485z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hcvk4xwoyc",
    d: "M0.028 0.046L41.195 0.046 41.195 17.476 0.028 17.476z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cafjx5nebe",
    d: "M0 0.061L4.314 0.061 4.314 0.511 0 0.511z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "jr13ijq6bg",
    d: "M0 0.001L4.314 0.001 4.314 0.45 0 0.45z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0076FF",
    d: "M32.55 13.129c.251-.128.424-.388.424-.69v-.897c0-.427-.347-.774-.775-.774h-1.334c-.1 0-.134.066-.077.147l1.49 2.128c.057.082.183.13.272.086M30.865 27.15h1.154c.1 0 .262.003.359-.02.341-.08.596-.388.596-.754v-.898c0-.301-.173-.56-.424-.688-.089-.045-.215.004-.272.085l-1.49 2.128c-.057.082-.022.148.077.148",
    transform: "translate(-694.000000, -539.000000) translate(713.500000, 563.000000) rotate(-90.000000) translate(-713.500000, -563.000000) translate(690.000000, 544.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-694.000000, -539.000000) translate(713.500000, 563.000000) rotate(-90.000000) translate(-713.500000, -563.000000) translate(690.000000, 544.000000) translate(20.070000, 0.028260)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "zmmvmkdopb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5wjckmvxoa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0076FF",
    d: "M13.077 15.337L2.487.21C2.43.128 2.303.062 2.204.062H.194C.096.062.039.139.068.234l4.535 15.078c.029.095.133.173.232.173H13c.1 0 .134-.066.077-.148",
    mask: "url(#zmmvmkdopb)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0076FF",
    d: "M33.07 22.405h-8.166c-.1 0-.203.078-.232.173l-4.535 15.078c-.029.095.028.172.128.172h2.009c.1 0 .226-.066.283-.147l10.59-15.128c.057-.082.023-.148-.077-.148",
    transform: "translate(-694.000000, -539.000000) translate(713.500000, 563.000000) rotate(-90.000000) translate(-713.500000, -563.000000) translate(690.000000, 544.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-694.000000, -539.000000) translate(713.500000, 563.000000) rotate(-90.000000) translate(-713.500000, -563.000000) translate(690.000000, 544.000000) translate(4.500000, 10.198260)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "6218fx2bsd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hcvk4xwoyc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0076FF",
    d: "M6.34 10.63c2.246.548 4.65.957 5.491.957h20.1c1.78 0 9.264-1.622 9.264-2.826s-7.433-2.827-9.264-2.827h-20.1c-.84 0-3.245.41-5.49.957-.097.023-.215-.027-.263-.114L2.406.203C2.358.116 2.238.046 2.138.046H.171c-.1 0-.161.078-.139.175l1.87 7.982c.023.096.121.181.22.189l4.531.355c.1.008.1.02 0 .028l-4.53.355c-.1.008-.198.092-.221.19L.032 17.3c-.022.097.04.176.14.176h1.966c.1 0 .22-.07.268-.157l3.672-6.574c.048-.087.166-.138.262-.114",
    mask: "url(#6218fx2bsd)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0076FF",
    d: "M9.005 12.586l14.248.758c.099.005.156-.068.127-.163l-.637-2.12c-.029-.095-.133-.168-.232-.162l-14.021.745c-.1.006-.14.08-.092.167l.34.608c.048.087.168.162.267.167",
    transform: "translate(-694.000000, -539.000000) translate(713.500000, 563.000000) rotate(-90.000000) translate(-713.500000, -563.000000) translate(690.000000, 544.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-694.000000, -539.000000) translate(713.500000, 563.000000) rotate(-90.000000) translate(-713.500000, -563.000000) translate(690.000000, 544.000000) translate(0.000000, 11.818260)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "79yvl84a0f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cafjx5nebe"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0076FF",
    d: "M4.06.062L.075.274c-.099.005-.099.013 0 .019L4.17.51c.1.005.162-.07.139-.166L4.28.227C4.26.131 4.16.057 4.061.062",
    mask: "url(#79yvl84a0f)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-694.000000, -539.000000) translate(713.500000, 563.000000) rotate(-90.000000) translate(-713.500000, -563.000000) translate(690.000000, 544.000000) translate(0.000000, 25.588260)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "zlgo0404ch",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jr13ijq6bg"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0076FF",
    d: "M4.17.001L.074.22c-.099.005-.099.014 0 .019L4.061.45c.099.005.198-.069.22-.166L4.31.167C4.332.07 4.269-.004 4.17 0",
    mask: "url(#zlgo0404ch)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0076FF",
    d: "M8.49 26.274l14.021.746c.1.005.203-.068.232-.163l.637-2.12c.029-.095-.028-.168-.128-.163l-14.247.758c-.099.005-.219.08-.267.167l-.34.608c-.049.087-.007.162.092.167",
    transform: "translate(-694.000000, -539.000000) translate(713.500000, 563.000000) rotate(-90.000000) translate(-713.500000, -563.000000) translate(690.000000, 544.000000)"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAirplane, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/airplane.035a1817.svg";
export { ForwardRef as ReactComponent };